import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './AuthContext';
import { RequireAuth, RequireStudent, RequireAdmin } from './guards';

import AppLayout from './AppLayout';
import LoginPage from './LoginPage';
import AccessDenied from './AccessDenied';
import AdminPage from './AdminPage';
import CoursePage from './CoursePage';
import LessonPage from './LessonPage';

export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <Routes>
          {/* 헤더 없이 보여줄 페이지 */}
          <Route path="/login" element={<LoginPage />} />
          <Route path="/access-denied" element={<AccessDenied />} />

          {/* 로그인 필요 */}
          <Route element={<RequireAuth />}>
            {/* 로그인 후 공통 프레임 */}
            <Route element={<AppLayout />}>
              {/* 관리자 */}
              <Route element={<RequireAdmin />}>
                <Route path="/admin" element={<AdminPage />} />
              </Route>

              {/* 수강생 */}
              <Route element={<RequireStudent />}>
                <Route path="/" element={<CoursePage />} />
                <Route path="/course" element={<CoursePage />} />
                <Route path="/lesson/:lessonId" element={<LessonPage />} />
              </Route>
            </Route>
          </Route>

          {/* 기타 경로 */}
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </AuthProvider>
    </BrowserRouter>
  );
}